function toGermanTime(date) {
    // Berechnet den Zeitunterschied zwischen UTC und der deutschen Zeitzone in Millisekunden
    // Berlin liegt in der Regel in UTC+1 oder UTC+2 (wegen Sommerzeit)
    let timezoneOffsetInMs = date.getTimezoneOffset() * 60000; // lokale Zeitzone in Millisekunden
    let berlinOffsetInMs = 3600000; // Standardmäßig UTC+1 in Millisekunden

    // Prüft auf Sommerzeit in der deutschen Zeitzone
    if (isDST(date)) {
        berlinOffsetInMs += 3600000; // Fügt eine zusätzliche Stunde für Sommerzeit hinzu
    }

    // Erstellt das neue Datum-Objekt mit der korrekten Zeitzone
    let germanTime = new Date(date.getTime() + timezoneOffsetInMs + berlinOffsetInMs);
    return germanTime;
}

function isDST(date) {
    let year = date.getFullYear();
    // Erster Tag des Jahres in der lokalen Zeitzone
    let startDST = new Date(year, 2, 31); // 31. März
    // Letzter Tag des Jahres in der lokalen Zeitzone
    let endDST = new Date(year, 9, 31); // 31. Oktober

    // Den letzten Sonntag im März finden
    startDST.setDate(31 - (startDST.getDay() + 1) % 7);
    // Den letzten Sonntag im Oktober finden
    endDST.setDate(31 - (endDST.getDay() + 1) % 7);

    // Prüfen, ob das Datum in den Sommerzeit-Periode fällt
    return date >= startDST && date < endDST;
}

let publicHolidays = [
  // 2023
  "2023-01-01", // Neujahr
  "2023-04-07", // Karfreitag
  "2023-04-09", // Ostersonntag
  "2023-04-10", // Ostermontag
  "2023-05-01", // Tag der Arbeit
  "2023-05-18", // Christi Himmelfahrt
  "2023-06-07", // Pfingstmontag
  "2023-10-03", // Tag der Deutschen Einheit
  "2023-10-31", // Reformationstag
  "2023-12-25", // Weihnachtstag
  "2023-12-26", // Zweiter Weihnachtstag

  // 2024
  "2024-01-01", // Neujahr
  "2024-03-29", // Karfreitag
  "2024-03-31", // Ostersonntag
  "2024-04-01", // Ostermontag
  "2024-05-01", // Tag der Arbeit
  "2024-05-09", // Christi Himmelfahrt
  "2024-05-20", // Pfingstmontag
  "2024-10-03", // Tag der Deutschen Einheit
  "2024-10-31", // Reformationstag
  "2024-12-24", // Weihnachtstag
  "2024-12-25", // Weihnachtstag
  "2024-12-26", // Zweiter Weihnachtstag
  "2024-12-31", // Silvester

  // 2025
  "2025-01-01", // Neujahr
  "2025-04-18", // Karfreitag
  "2025-04-20", // Ostersonntag
  "2025-04-21", // Ostermontag
  "2025-05-01", // Tag der Arbeit
  "2025-05-29", // Christi Himmelfahrt
  "2025-06-09", // Pfingstmontag
  "2025-10-03", // Tag der Deutschen Einheit
  "2025-10-31", // Reformationstag
  "2025-12-24", 
  "2025-12-25", // Weihnachtstag
  "2025-12-26",  // Zweiter Weihnachtstag


  // 2026
  "2026-01-01", // Neujahr
  "2026-04-03", // Karfreitag
  "2026-04-05", // Ostersonntag
  "2026-04-06", // Ostermontag
  "2026-05-01", // Tag der Arbeit
  "2026-05-14", // Christi Himmelfahrt
  "2026-05-25", // Pfingstmontag
  "2026-10-03", // Tag der Deutschen Einheit
  "2026-10-31", // Reformationstag
  "2026-12-25", // Erster Weihnachtstag
  "2026-12-26", // Zweiter Weihnachtstag
  
  // 2027
  "2027-01-01", // Neujahr
  "2027-03-26", // Karfreitag
  "2027-03-28", // Ostersonntag
  "2027-03-29", // Ostermontag
  "2027-05-01", // Tag der Arbeit
  "2027-05-06", // Christi Himmelfahrt
  "2027-05-17", // Pfingstmontag
  "2027-10-03", // Tag der Deutschen Einheit
  "2027-10-31", // Reformationstag
  "2027-12-25", // Erster Weihnachtstag
  "2027-12-26", // Zweiter Weihnachtstag

    // 2028
  "2028-01-01", // Neujahr
  "2028-04-14", // Karfreitag
  "2028-04-16", // Ostersonntag
  "2028-04-17", // Ostermontag
  "2028-05-01", // Tag der Arbeit
  "2028-05-25", // Christi Himmelfahrt
  "2028-06-04", // Pfingstmontag
  "2028-10-03", // Tag der Deutschen Einheit
  "2028-10-31", // Reformationstag
  "2028-12-25", // Erster Weihnachtstag
  "2028-12-26", // Zweiter Weihnachtstag

  // 2029
  "2029-01-01", // Neujahr
  "2029-03-30", // Karfreitag
  "2029-04-01", // Ostersonntag
  "2029-04-02", // Ostermontag
  "2029-05-01", // Tag der Arbeit
  "2029-05-10", // Christi Himmelfahrt
  "2029-05-21", // Pfingstmontag
  "2029-10-03", // Tag der Deutschen Einheit
  "2029-10-31", // Reformationstag
  "2029-12-25", // Erster Weihnachtstag
  "2029-12-26", // Zweiter Weihnachtstag

  
];

function isTomorrow(dateToCheck) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const tomorrowDate = new Date(currentDate.getTime() + (24 * 60 * 60 * 1000));
    dateToCheck.setHours(0, 0, 0, 0);
    return dateToCheck.getTime() === tomorrowDate.getTime();
}


function getNextWorkDay(date) {
  do {
    date = toGermanTime(date);
    date.setDate(date.getDate() + 1);
  } while (date.getDay() === 0 || date.getDay() === 6 || publicHolidays.includes(date.toISOString().split('T')[0]));

  return date;
}

function getReceivalDate() {
  let currentDate = toGermanTime(new Date());
  let currentHour = currentDate.getHours();


  const todayISO = currentDate.toISOString().split('T')[0];

  const tomorrow = new Date(currentDate);
  tomorrow.setDate(currentDate.getDate() + 1);
  const tomorrowISO = tomorrow.toISOString().split('T')[0];

  if (
    // Freitag nach Cutoff
    (currentDate.getDay() === 5 && currentHour >= cuttoffTime)

    // Samstag oder Sonntag
    || currentDate.getDay() === 6
    || currentDate.getDay() === 0

    // Heute ist Feiertag
    || publicHolidays.includes(todayISO)

    // Nach Cutoff UND morgen ist Feiertag
    || (currentHour >= cuttoffTime && publicHolidays.includes(tomorrowISO))
  ) {

    
      currentDate = getNextWorkDay(new Date(currentDate.getTime()));
  } else if (currentHour >= cuttoffTime) { 
      currentDate.setDate(currentDate.getDate() + 1);
  } else {
  }

  let nextWorkingDay = getNextWorkDay(currentDate);
  let nextNextWorkingDay = getNextWorkDay(nextWorkingDay);
  let thirdNextWorkingDay = getNextWorkDay(nextNextWorkingDay);
  

  return [nextWorkingDay, nextNextWorkingDay, thirdNextWorkingDay];
}

function getShippingDay() {
  let now = toGermanTime(new Date());
  let currentHour = now.getHours();
  if (currentHour < cuttoffTime) {
    return -2;
  } else {
    let nextWorkDay = getNextWorkDay(new Date(now));
    if (isTomorrow(nextWorkDay)) {
      return -1;
    } else {
      return nextWorkDay.getDay();
    }
  }
  
}

function getTimeUntil3pmNextWorkDay() {
  let now = toGermanTime(new Date());
  let currentHour = now.getHours();
  let diffMs = 0;
  if (currentHour < cuttoffTime && now.getDay() !== 0 && now.getDay() !== 6 && !publicHolidays.includes(now.toISOString().split('T')[0])) {
    let today3pm = new Date(now);
    today3pm.setHours(cuttoffTime, 0, 0, 0)
    diffMs = today3pm - now;
  } else {
    let nextWorkDay = getNextWorkDay(new Date(now));
    nextWorkDay.setHours(cuttoffTime, 0, 0, 0);
    diffMs = nextWorkDay - now;  
  }
  
  let diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  let diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60)) + 1;

  if (diffHours > 24) {
    diffHours = 24;
  }

  if (diffHours == 0) {
    return `${diffMinutes} ${minutes}`;
  } else {
    return `${diffHours} ${hours} ${and} ${diffMinutes} ${minutes}`;  
  }
 
}

function updateWebPage() {
  let timeUntil3pmNextWorkDay = getTimeUntil3pmNextWorkDay();
  
  let receivalDates = getReceivalDate();
  if (market == "de") { //in order to determine which country shopify selected

    const formatDate = (d) =>
      String(d.getDate()).padStart(2, '0') + '.' +
      String(d.getMonth() + 1).padStart(2, '0');

    var resultShippingTimeCalculator = document.getElementById("resultShippingTimeCalculator");
    if(resultShippingTimeCalculator !== null) {
        resultShippingTimeCalculator.innerHTML =
          weekdays[receivalDates[0].getDay()] + " (" + formatDate(receivalDates[0]) + ") " +
          and + " " +
          weekdays[receivalDates[1].getDay()] + " (" + formatDate(receivalDates[1]) + ")";
    }
    
    var expressResultShippingTimeCalculator = document.getElementById("expressResultShippingTimeCalculator");
    if(expressResultShippingTimeCalculator !== null) {
      
        expressResultShippingTimeCalculator.innerHTML = weekdays[receivalDates[0].getDay()] + " (" + formatDate(receivalDates[0]) + ")";
    }

    var laroidResultShippingTimeCalculator = document.getElementById("laroidResultShippingTimeCalculator");
    if(laroidResultShippingTimeCalculator !== null) {
        laroidResultShippingTimeCalculator.innerHTML = weekdays[receivalDates[1].getDay()] + " (" + formatDate(receivalDates[1]) + ") " +
          and + " " +
          weekdays[receivalDates[2].getDay()] + " (" + formatDate(receivalDates[2]) + ")";
    }


  } else {
      let shippingDay = getShippingDay();
      var resultShippingTimeCalculator = document.getElementById("resultShippingTimeCalculator");
      if(resultShippingTimeCalculator !== null) {
        if (shippingDay == -2) {
          resultShippingTimeCalculator.innerHTML = today;  
        } else if (shippingDay == -1) {
          resultShippingTimeCalculator.innerHTML = tomorrow;
        } else {
          resultShippingTimeCalculator.innerHTML = weekdays[shippingDay];
        }
      }
  }

    var resultTimeUntil3pmNextWorkday = document.getElementById("resultTimeUntil3pmNextWorkday");
    if(resultTimeUntil3pmNextWorkday !== null) {
        resultTimeUntil3pmNextWorkday.innerHTML = timeUntil3pmNextWorkDay;
    }

    var resultTimeUntil3pmNextWorkday2 = document.getElementById("resultTimeUntil3pmNextWorkday2"); // Sometimes it's needed twice on the page
    if(resultTimeUntil3pmNextWorkday2 !== null) {
        resultTimeUntil3pmNextWorkday2.innerHTML = timeUntil3pmNextWorkDay;
    }

}


updateWebPage();
setInterval(updateWebPage, 60000);
